<template>
  <div class="login">
    <div class="title">{{ $t('acessStudy') }}</div>

    <VeeForm v-slot="{ errors }" @submit="login">
      <Transition name="fade">
        <div v-if="Object.keys(errors).length > 0" class="error-container">
          <div class="error-icon">!</div>
          <div v-if="error" class="error-text">{{ error }}</div>
          <div v-else-if="errors['email']" class="error-text">{{ $t('errorMessage.emailInvalid') }}</div>
          <div v-else-if="errors['password']" class="error-text">{{ $t('errorMessage.passwordInvalid') }}</div>
        </div>
      </Transition>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('emailAddress') }}</div>
        </div>

        <Field name="email" rules="required|email" type="text" :placeholder="$t('emailAddress')" />
      </div>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('password') }}</div>
          <div class="show-container" @click="showPassword = !showPassword">
            <div class="show-icon" :class="{ active: showPassword }"></div>
            <div class="show-text">{{ showPassword ? $t('hide') : $t('show') }}</div>
          </div>
        </div>

        <Field name="password" rules="required|min:6" :type="showPassword ? 'text' : 'password'" :placeholder="$t('password')" />
      </div>

      <button class="study-button main" :class="{ loading: loading }">
        {{ loading ? $t('connect') : $t('seeTheStudy') }}
      </button>
    </VeeForm>

    <RouterLink :to="{ name: 'userForgetPassword' }" class="text-button">{{ $t('forgottenPassword') }}</RouterLink>

    <RouterLink :to="{ name: 'Login' }" class="jll-login text-button">{{ $t('userJLLLogin') }}</RouterLink>
  </div>
</template>

<script>
import { Field, Form as VeeForm } from 'vee-validate';

export default {
  components: {
    VeeForm,
    Field,
  },

  data() {
    return {
      showPassword: false,
      error: null,
      loading: false,
    };
  },

  methods: {
    login(values) {
      if (this.loading) return;
      this.loading = true;
      this.error = null;

      this.$store
        .dispatch('clientLogin', { email: values.email, password: values.password })
        .then(() => {
          this.loading = false;

          this.$store
            .dispatch('updateUserInfo')
            .then(() => {
              this.$router.push({ name: 'studyList' });
            })
            .catch(() => {
              this.loading = false;
              this.error = 'Error';
            });
        })
        .catch(e => {
          this.loading = false;
          switch (e.code) {
            case -1:
              this.error = 'Adresse mail ou mot de passe incorrect. Réessayez ou cliquez sur "Mot de passe oublié" pour le réinitialiser.';
              break;
            default:
              this.error = e.error;
              break;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';

.jll-login {
  position: absolute;
  min-width: 512px;
  bottom: 24px;
  left: 0;
  margin: 0;
  width: auto;
}
</style>
